import { followAPI } from '../../utils/followAPI';

export const FOLLOW_ACTIONS = {
	LOAD_FOLLOWS_START: 'LOAD_FOLLOWS_START',
	LOAD_FOLLOWS_SUCCESS: 'LOAD_FOLLOWS_SUCCESS',
	LOAD_FOLLOWS_ERROR: 'LOAD_FOLLOWS_ERROR',
	ADD_FOLLOW_SUCCESS: 'ADD_FOLLOW_SUCCESS',
	REMOVE_FOLLOW_SUCCESS: 'REMOVE_FOLLOW_SUCCESS',
	FOLLOW_ERROR: 'FOLLOW_ERROR',
	CLEAR_FOLLOW_ERROR: 'CLEAR_FOLLOW_ERROR',
};

const initialState = {
	brandIds: [],
	loading: false,
	error: null,
	initialized: false,
};

export const followReducer = (state = initialState, action) => {
	switch (action.type) {
		case FOLLOW_ACTIONS.LOAD_FOLLOWS_START:
			return { ...state, loading: true, error: null };

		case FOLLOW_ACTIONS.LOAD_FOLLOWS_SUCCESS:
			return {
				...state,
				loading: false,
				brandIds: action.payload.brandIds,
				initialized: true,
				error: null,
			};

		case FOLLOW_ACTIONS.LOAD_FOLLOWS_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
				initialized: true,
			};

		case FOLLOW_ACTIONS.ADD_FOLLOW_SUCCESS:
			return {
				...state,
				brandIds: [...state.brandIds, action.payload.brandId],
				error: null,
			};

		case FOLLOW_ACTIONS.REMOVE_FOLLOW_SUCCESS:
			return {
				...state,
				brandIds: state.brandIds.filter((id) => id !== action.payload.brandId),
				error: null,
			};

		case FOLLOW_ACTIONS.FOLLOW_ERROR:
			return { ...state, error: action.payload };

		case FOLLOW_ACTIONS.CLEAR_FOLLOW_ERROR:
			return { ...state, error: null };

		default:
			return state;
	}
};

export const followActions = {
	loadFollows: (userId) => async (dispatch) => {
		dispatch({ type: FOLLOW_ACTIONS.LOAD_FOLLOWS_START });
		try {
			const res = await followAPI.getFollows();
			dispatch({
				type: FOLLOW_ACTIONS.LOAD_FOLLOWS_SUCCESS,
				payload: { brandIds: res.follows || [] },
			});
		} catch (error) {
			dispatch({
				type: FOLLOW_ACTIONS.LOAD_FOLLOWS_ERROR,
				payload: error.message,
			});
		}
	},

	addFollow: (userId, brandId) => async (dispatch) => {
		try {
			await followAPI.addFollow(brandId);
			dispatch({
				type: FOLLOW_ACTIONS.ADD_FOLLOW_SUCCESS,
				payload: { brandId },
			});
		} catch (error) {
			dispatch({
				type: FOLLOW_ACTIONS.FOLLOW_ERROR,
				payload: error.message,
			});
		}
	},

	removeFollow: (userId, brandId) => async (dispatch) => {
		try {
			await followAPI.removeFollow(brandId);
			dispatch({
				type: FOLLOW_ACTIONS.REMOVE_FOLLOW_SUCCESS,
				payload: { brandId },
			});
		} catch (error) {
			dispatch({
				type: FOLLOW_ACTIONS.FOLLOW_ERROR,
				payload: error.message,
			});
		}
	},

	toggleFollow: (userId, brandId) => (dispatch, getState) => {
		const { brandIds } = getState().follows;
		if (brandIds.includes(brandId)) {
			dispatch(followActions.removeFollow(userId, brandId));
		} else {
			dispatch(followActions.addFollow(userId, brandId));
		}
	},

	clearError: () => ({ type: FOLLOW_ACTIONS.CLEAR_FOLLOW_ERROR }),
};

export const followSelectors = {
	getFollowedBrandIds: (state) => state?.follows?.brandIds || [],
	isFollowing: (state, brandId) => !!state?.follows?.brandIds?.includes(brandId),
	isInitialized: (state) => !!state?.follows?.initialized,
	getError: (state) => state?.follows?.error,
};
